export const messages = {
  en: {
    chainInoutOrderManage: {
      queryCondition: 'Query Conditions',
      selectOutType: 'Please select outbound type',
      inputInOrderId: 'Please enter inbound order number',
      query: 'Query',
      collectOrder: 'Collection Order',
      orderId: 'Order ID',
      inOrderId: 'Inbound Order No.',
      applicant: 'Applicant',
      supplierId: 'Supplier ID',
      supplierName: 'Supplier Name',
      orderStatus: 'Order Status',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete'
    },
    addChainInoutOrder: {
      addTitle: 'Add Collection Order',
      supplierId: 'Supplier ID',
      supplierIdPlaceholder: 'Required, please enter supplier ID',
      supplierIdRequired: 'Supplier ID is required',
      supplierIdMaxLength: 'Supplier ID cannot exceed 32 characters',
      cancel: 'Cancel',
      save: 'Save',
      saveSuccess: 'Saved successfully'
    },
    editChainInoutOrder: {
      editTitle: 'Edit Collection Order',
      supplierId: 'Supplier ID',
      supplierIdPlaceholder: 'Required, please enter supplier ID',
      supplierIdRequired: 'Supplier ID is required',
      supplierIdMaxLength: 'Supplier ID cannot exceed 32 characters',
      orderIdRequired: 'Order ID is required',
      cancel: 'Cancel',
      save: 'Save',
      updateSuccess: 'Updated successfully'
    },
    deleteChainInoutOrder: {
      confirmTitle: 'Please confirm your operation!',
      confirmText: 'Confirm to delete collection order?',
      cancel: 'Cancel',
      confirm: 'Confirm Delete!',
      deleteSuccess: 'Deleted successfully'
    }
  },
  zh: {
    chainInoutOrderManage: {
      queryCondition: '查询条件',
      selectOutType: '请选择出库类型',
      inputInOrderId: '请输入入库单号',
      query: '查询',
      collectOrder: '采集订单',
      orderId: '订单ID',
      inOrderId: '入库单号',
      applicant: '申请人',
      supplierId: '供应商ID',
      supplierName: '供应商名称',
      orderStatus: '订单状态',
      operation: '操作',
      edit: '修改',
      delete: '删除'
    },
    addChainInoutOrder: {
      addTitle: '添加采集订单',
      supplierId: '供应商ID',
      supplierIdPlaceholder: '必填，请填写供应商ID',
      supplierIdRequired: '供应商ID不能为空',
      supplierIdMaxLength: '供应商ID不能超过32个字符',
      cancel: '取消',
      save: '保存',
      saveSuccess: '保存成功'
    },
    editChainInoutOrder: {
      editTitle: '修改采集订单',
      supplierId: '供应商ID',
      supplierIdPlaceholder: '必填，请填写供应商ID',
      supplierIdRequired: '供应商ID不能为空',
      supplierIdMaxLength: '供应商ID不能超过32个字符',
      orderIdRequired: '采集订单ID不能为空',
      cancel: '取消',
      save: '保存',
      updateSuccess: '修改成功'
    },
    deleteChainInoutOrder: {
      confirmTitle: '请确认您的操作!',
      confirmText: '确定删除采集订单?',
      cancel: '点错了',
      confirm: '确认删除!',
      deleteSuccess: '删除成功'
    }
  }
}